import { useEffect, useState, useCallback } from 'react';
import Api from '@app/api';

const prizeMapping = {
  certificate: 'participation',
  diploma: 'achievement',
  charter: 'merit'
};

const useDiplomasStatistics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await Api.teachers.diplomasStatistics.index();
      const processedData = data?.reduce((acc, item) => {
        const prize = item?.participation?.prize;
        const mappedPrize = prizeMapping[prize] || prize;
        if (mappedPrize) {
          acc[mappedPrize] = (acc[mappedPrize] || 0) + 1;
        }
        return acc;
      }, {});

      const result = Object.keys(prizeMapping).reduce((acc, key) => {
        acc[prizeMapping[key]] = processedData[prizeMapping[key]] || 0;
        return acc;
      }, {});

      result.total = Object.values(result).reduce((sum, count) => sum + count, 0);
      setData(result);
    } catch (err) {
      setError(err);
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useDiplomasStatistics;
